import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiClient } from '@/lib/apiClient'
import { API_ROUTES } from '@/constants/apiRoutes'
import { AdminDownloadList, AdminDownloadState, AdminDownloadItemAction } from '@/types/index'

// GET LIST
export const getDownloadList = createAsyncThunk<AdminDownloadState>(
    "adminDownload/getDownloadList",
    async () => {
        const res = await apiClient.get(API_ROUTES.ADMIN_DOWNLOAD_LIST_ENDPOINT)
        return (res as any).data ?? res
    }
)

// DELETE ITEM
export const deleteDownloadItem = createAsyncThunk<
    AdminDownloadItemAction,
    { id: number }
>(
    "adminDownload/deleteDownloadItem",
    async ({ id }) => {
        const res = await apiClient.delete(`${API_ROUTES.ADMIN_DOWNLOAD_LIST_ENDPOINT}/${id}`);

        // đảm bảo trả đúng kiểu
        return (res as any).data as AdminDownloadItemAction;
    }
);

// ADD ITEM
export const addDownloadItem = createAsyncThunk<
    AdminDownloadItemAction,
    { name: string; note: string; item_parameters: Record<string, any> }
>(
    "adminDownload/addDownloadItem",
    async ({ name, note, item_parameters }) => {
        const res = await apiClient.post(
            API_ROUTES.ADMIN_DOWNLOAD_LIST_ENDPOINT,
            {
                name,
                note,
                item_parameters
            }
        );
        return (res as any).data as AdminDownloadItemAction;
    }
);

export const editDownloadItem = createAsyncThunk<
    AdminDownloadItemAction,
    { id: number; name: string; note: string; item_parameters: Record<string, any> }
>(
    "adminDownload/editDownloadItem",
    async ({ id, name, note, item_parameters }) => {
        const res = await apiClient.patch(
            `${API_ROUTES.ADMIN_DOWNLOAD_LIST_ENDPOINT}/${id}`,
            {
                name,
                note,
                item_parameters
            }
        );
        return (res as any).data as AdminDownloadItemAction;
    }
);

const initialState: AdminDownloadList = {
    downloads: [],
    loading: false,
    error: null,
}

const adminDownloadSlice = createSlice({
    name: 'adminDownload',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // GET
            .addCase(getDownloadList.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(getDownloadList.fulfilled, (state, action) => {
                state.downloads = action.payload.items || action.payload
                state.loading = false
            })
            .addCase(getDownloadList.rejected, (state, action) => {
                state.error = action.error.message || 'Error'
                state.loading = false
            })

            // DELETE
            .addCase(deleteDownloadItem.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(deleteDownloadItem.fulfilled, (state, action) => {
                state.downloads = state.downloads.filter(
                    (d) => d.id !== action.meta.arg.id
                )
                state.loading = false
            })
            .addCase(deleteDownloadItem.rejected, (state, action) => {
                state.error = action.error.message || 'Error'
                state.loading = false
            })
            // ADD
            .addCase(addDownloadItem.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(addDownloadItem.fulfilled, (state, action) => {
                state.loading = false
            })
            .addCase(addDownloadItem.rejected, (state, action) => {
                state.error = action.error.message || 'Error'
                state.loading = false
            })
            // EDIT
            .addCase(editDownloadItem.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(editDownloadItem.fulfilled, (state, action) => {
                state.loading = false
            })
            .addCase(editDownloadItem.rejected, (state, action) => {
                state.error = action.error.message || 'Error'
                state.loading = false
            })
    },
})

export default adminDownloadSlice.reducer
